<template>
	<div class="index">
		<div class="container clearfix">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item>下载中心</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<ul>
				<li v-for="item in dataList">
					<div class="box clearfix">
						<div class="box-left">
							<p style="font-size:18px;">{{item.title}}</p>
							<p style="font-size:13px;">
								<span><i class="el-icon-download"></i>下载量：<span>{{item.countNum}}</span></span>
								<span><i class="el-icon-info"></i>文件大小：<span>{{item.fileSize}}</span></span>
							</p>
						</div>
						<div class="box-right clearfix">
							<a :href="item.fileUrl" class="clearfix" target="_blank">
								<i class="el-icon-download"></i>下载
							</a>
						</div>
					</div>
				</li>
			</ul>
			<div class="pages">
				<el-pagination
		            @current-change="handleCurrentChange"
					background
					layout="prev, pager, next"
					v-if="total>1?true:false"
					:total="total"
					pagesize="10"
					style="float:right">
				</el-pagination>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				dataList:[],
				total:1,
				currentPage:1,
			}
		},
		methods:{
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getData();
	        },
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.downLoadListApi+'/page/'+this.currentPage,
					data: {},
				})
				.then((res) => {
					this.dataList = res.data.data;
					this.total = parseInt(res.data.total);
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.index{
	background-color:#eee;
	.container{
		.padding(10,10,10,10);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			span{
				color: #00A0FF;
			}
		}
		ul{
			.margin-bottom(40);
			li{
				width:100%;
				.margin-top(20);
				.margin-bottom(20);
				background-color:#fff;
				.box{
					width:100%;
					position:relative;
					.padding(10,30,10,30);
					.box-left{
						width:80%;
						float:left;
						p{
							.margin-top(10);
							.margin-bottom(10);
							overflow:hidden;
							white-space:nowrap;
							text-overflow:ellipsis;
							span{
								color:#c8c8c8;
								.margin-right(20);
								.font-size(22);
								span{
									.font-size(20);
									color:#969696;
								}
								i{
									.font-size(20);
									.margin-right(5);
								}
							}
						}
					}
					.box-right{
						width:20%;
						float:left;
						a{
							display:block;
							position:absolute;
							top:28%;
							.right(20);
							.padding(10,20,10,20);
							.font-size(24);
							background:#229dfe;
							.border-radius(10);
							color:#fff;
						}
						
					}
				}
			}
		}
		
	}
}
.clearfix:after {
	content: ".";
	display: block;
	height: 0;
	font-size: 0;
	clear: both;
	visibility: hidden;
}
.clearfix {
	zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/DownLoad/DownLoad.vue